import React, { createContext, useContext } from "react";
import { useUser } from "~/Auth/useUser";
import { MenuAuthorizations } from "~/gql/types2";

type ProjectChargeEditorContextData = {
  newProjectChargeEditor: boolean;
};

export const ProjectChargeEditorContext =
  createContext<ProjectChargeEditorContextData>(null!);

export const ProjectChargeEditorProvider: React.FC = ({ children }) => {
  const { menus: menuAuths } = useUser();

  const newProjectChargeEditorStatus =
    menuAuths.has(MenuAuthorizations.NewProjectChargeEditor) &&
    window.config.featureFlags.newProjectChargeEditor
      ? true
      : false;

  return (
    <ProjectChargeEditorContext.Provider
      value={{
        newProjectChargeEditor: newProjectChargeEditorStatus,
      }}
    >
      {children}
    </ProjectChargeEditorContext.Provider>
  );
};

const useProviderContext = (fn: string): ProjectChargeEditorContextData => {
  const context = useContext(ProjectChargeEditorContext);

  if (!context) {
    throw new Error(
      `Cannot call ${fn} outside of a ProjectChargeEditorProvider`
    );
  }

  return context;
};

export function useNewProjectChargeEditor(): boolean {
  const context = useProviderContext("useNewProjectChargeEditor");

  const { newProjectChargeEditor } = context;

  return newProjectChargeEditor;
}
